import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import i18n from "../../i18n/i18n";
import CourseListItems from "../CourseListItem/CourseListItem";

function MasterYourSkills() {
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get("https://backend.dev.puremagicit.com/ae/elms-events");
      if (response.data && Array.isArray(response.data)) {
        // Map API data to the format expected by CourseListItems
        const mappedCourses = response.data.map(item => ({
          id: item.id || "-",
          course_name: item.title || "-",
          course_image: item.featuredImage || "default-course.jpg", // Fallback image
          price: item.price !== null ? item.price : "-",
          previous_price: null,
          duration: "-", // Default to dash as requested
          no_lectures: "-", // Default to dash
          instructor_name: "Expert", // Placeholder
          instructor_image: "",
          status: "active",
          slug: item.id ? item.id.toString() : "-",
          tags: ["Skills"],
          isMasterYourSkills: true
        }));
        setCourses(mappedCourses);
      }
    } catch (error) {
      console.error("Error fetching Master Your Skills data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  return (
    <div>
      <div className="section page-banner" style={{ height: "20rem" }} dir="ltr">
        <img
          className="shape-1 animation-round"
          src={process.env.PUBLIC_URL + "/images/shape/shape-8.png"}
          alt="shape"
        />
        <div className="container">
          <div className="page-banner-content">
            <ul className="breadcrumb">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">Master Your Skills</li>
            </ul>
            <h2 className="title">
              Master Your <span>Skills</span>
            </h2>
          </div>
        </div>
        <div className="shape-icon-box">
          <img
            className="icon-shape-1 animation-left"
            src={process.env.PUBLIC_URL + "/images/shape/shape-5.png"}
            alt="shape"
          />
          <div className="box-content">
            <div className="box-wrapper">
              <i className="flaticon-badge"></i>
            </div>
          </div>
          <img
            className="icon-shape-2"
            src={process.env.PUBLIC_URL + "/images/shape/shape-6.png"}
            alt="shape"
          />
        </div>
        <img
          className="shape-3"
          src={process.env.PUBLIC_URL + "/images/shape/shape-24.png"}
          alt="shape"
        />
      </div>

      <div className="section pb-5" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="courses-wrapper-02" style={{ width: "100%" }}>
            <div className="row">
              {isLoading ? (
                <center>
                  <Spinner animation="border" variant="primary" />
                </center>
              ) : courses.length === 0 ? (
                <p className="p-4">{i18n.t("CategoryNoCourseFound")}</p>
              ) : (
                courses.map((course) => (
                  <CourseListItems course={course} key={course.id} />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MasterYourSkills;
